import {DEV_PUBLIC_KEY} from './project-identity.mjs';
/** Fail before importing the authenticated product. No session access. */
export function assertProject(url: string | undefined, key: string | undefined, ref: string, dev: boolean) {
 if (url !== `https://${ref}.supabase.co`) throw Error('Forkert Supabase-URL');
 if (dev) {
  if (key !== DEV_PUBLIC_KEY) throw Error('Forkert DEV-nøgle');
  return;
 }
 try {
  const payload = (key ?? '').split('.')[1] ?? '';
  const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
  const claims = JSON.parse(atob(normalized.padEnd(Math.ceil(normalized.length/4)*4, '=')));
  if (claims.ref === ref && claims.role === 'anon') return;
 } catch { /* Reject malformed keys without exposing them. */ }
 throw Error('Nøglen hører ikke til det forventede projekt');
}
